"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerGroupType = exports.TriggerType = exports.CommandContractType = exports.EthereumNetwork = void 0;
var EthereumNetwork;
(function (EthereumNetwork) {
    EthereumNetwork[EthereumNetwork["MAINNET"] = 1] = "MAINNET";
    EthereumNetwork[EthereumNetwork["GOERLI"] = 5] = "GOERLI";
    EthereumNetwork[EthereumNetwork["OPTIMISM"] = 10] = "OPTIMISM";
})(EthereumNetwork = exports.EthereumNetwork || (exports.EthereumNetwork = {}));
var CommandContractType;
(function (CommandContractType) {
    CommandContractType["CloseCommand"] = "CloseCommand";
    CommandContractType["AutoTakeProfitCommand"] = "AutoTakeProfitCommand";
    CommandContractType["BasicBuyCommand"] = "BasicBuyCommand";
    CommandContractType["BasicSellCommand"] = "BasicSellCommand";
    CommandContractType["SimpleAAVESellCommand"] = "SimpleAAVESell";
    CommandContractType["AaveStopLossCommand"] = "AaveStopLossCommand";
    CommandContractType["AaveStopLossCommandV2"] = "AaveStopLossCommandV2";
    CommandContractType["MakerStopLossCommandV2"] = "MakerStopLossCommandV2";
    CommandContractType["MakerAutoTakeProfitCommandV2"] = "MakerAutoTakeProfitCommandV2";
    CommandContractType["MakerBasicBuyCommandV2"] = "MakerBasicBuyCommandV2";
    CommandContractType["MakerBasicSellCommandV2"] = "MakerBasicSellCommandV2";
})(CommandContractType = exports.CommandContractType || (exports.CommandContractType = {}));
var TriggerType;
(function (TriggerType) {
    TriggerType[TriggerType["StopLossToCollateral"] = 1] = "StopLossToCollateral";
    TriggerType[TriggerType["StopLossToDai"] = 2] = "StopLossToDai";
    TriggerType[TriggerType["BasicBuy"] = 3] = "BasicBuy";
    TriggerType[TriggerType["BasicSell"] = 4] = "BasicSell";
    TriggerType[TriggerType["AutoTakeProfitToCollateral"] = 7] = "AutoTakeProfitToCollateral";
    TriggerType[TriggerType["AutoTakeProfitToDai"] = 8] = "AutoTakeProfitToDai";
    TriggerType[TriggerType["SimpleAAVESell"] = 9] = "SimpleAAVESell";
    TriggerType[TriggerType["AaveStopLossToCollateral"] = 10] = "AaveStopLossToCollateral";
    TriggerType[TriggerType["AaveStopLossToDebt"] = 11] = "AaveStopLossToDebt";
    TriggerType[TriggerType["MakerStopLossToCollateralV2"] = 101] = "MakerStopLossToCollateralV2";
    TriggerType[TriggerType["MakerStopLossToDaiV2"] = 102] = "MakerStopLossToDaiV2";
    TriggerType[TriggerType["MakerBasicBuyV2"] = 103] = "MakerBasicBuyV2";
    TriggerType[TriggerType["MakerBasicSellV2"] = 104] = "MakerBasicSellV2";
    TriggerType[TriggerType["MakerAutoTakeProfitToCollateralV2"] = 105] = "MakerAutoTakeProfitToCollateralV2";
    TriggerType[TriggerType["MakerAutoTakeProfitToDaiV2"] = 106] = "MakerAutoTakeProfitToDaiV2";
    // AaveStopLossToCollateralV2 = 107,
    // AaveStopLossToDebtV2 = 108,
    // AaveStopLossToCollateralV2 = 109,
    // AaveStopLossToDebtV2 = 110,
    TriggerType[TriggerType["AaveStopLossToCollateralV2"] = 111] = "AaveStopLossToCollateralV2";
    TriggerType[TriggerType["AaveStopLossToDebtV2"] = 112] = "AaveStopLossToDebtV2";
})(TriggerType = exports.TriggerType || (exports.TriggerType = {}));
var TriggerGroupType;
(function (TriggerGroupType) {
    TriggerGroupType[TriggerGroupType["SingleTrigger"] = 65535] = "SingleTrigger";
    TriggerGroupType[TriggerGroupType["ConstantMultiple"] = 1] = "ConstantMultiple";
})(TriggerGroupType = exports.TriggerGroupType || (exports.TriggerGroupType = {}));
//# sourceMappingURL=types.js.map